import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "text-center" }

import store from '@/store'
import {
  User,
  Money,
  ArrowUp,
  ArrowDown,
  ChatRound,
  Setting,
  UserFilled,
  MagicStick,
  DataBoard,
  Notebook, Postcard
} from '@element-plus/icons-vue'
import { can } from '@/helpers/utils'
import { computed } from 'vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'MainMenu',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const router = useRouter()
const handleLogout = () => {
  store.logout()
  router.replace('/')
}

const emit = __emit

const supportMessageCount = computed(() => store.state.chatSupportUserMessages.length)
const traderMessageCount = computed(() => store.state.exchanges
  .filter(e => e.traderId === store.state.user?.id)
  .reduce((carry, exchange) => {
    return carry + store.state.chatExchangeMessages.filter(c => c.chatId === exchange.uuid).length
  }, 0)
)
const customerMessageCount = computed(() => store.state.exchanges
  .filter(e => e.customerId === store.state.user?.id)
  .reduce((carry, exchange) => {
    return carry + store.state.chatExchangeMessages.filter(c => c.chatId === exchange.uuid).length
  }, 0)
)
const ticketsMessageCount = computed(() => store.state.chatSupportMessages.length)

const handleClick = () => {
  emit('close')
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    router: "",
    style: {"display":"flex","flex-direction":"column","justify-content":"space-between","flex":"1"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_menu_item, {
          index: "/",
          onClick: handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(User))
              ]),
              _: 1
            }),
            _createTextVNode(" Профиль")
          ]),
          _: 1
        }),
        (_unref(can)('DISPOSER_ONLY'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 0,
              index: "/disposer",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DataBoard))
                  ]),
                  _: 1
                }),
                _createTextVNode(" Панель управляющего")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(can)('VIEW_ACCOUNT_LIST'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 1,
              index: "/account",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Money))
                  ]),
                  _: 1
                }),
                _createTextVNode(" Счета")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(can)('VIEW_OFFER_LIST'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 2,
              index: "/trader",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowUp))
                  ]),
                  _: 1
                }),
                _createTextVNode(" Продажа USDT "),
                (traderMessageCount.value)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "warning",
                      style: {"margin-left":"8px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(traderMessageCount.value), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(can)('VIEW_OFFER_LIST'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 3,
              index: "/customer",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowDown))
                  ]),
                  _: 1
                }),
                _createTextVNode(" Покупка USDT "),
                (customerMessageCount.value)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "warning",
                      style: {"margin-left":"8px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(customerMessageCount.value), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(can)('VIEW_CHAT'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 4,
              index: "/support",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChatRound))
                  ]),
                  _: 1
                }),
                _createTextVNode(" Техподдержка "),
                (supportMessageCount.value)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "warning",
                      style: {"margin-left":"8px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(supportMessageCount.value), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(can)('VIEW_TICKETS'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 5,
              index: "/tickets",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChatRound))
                  ]),
                  _: 1
                }),
                _createTextVNode(" Тикеты "),
                (ticketsMessageCount.value)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "warning",
                      style: {"margin-left":"8px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(ticketsMessageCount.value), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(can)('VIEW_APPLICATION_SETTINGS'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 6,
              index: "/settings",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Setting))
                  ]),
                  _: 1
                }),
                _createTextVNode(" Настройки")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(can)('VIEW_USER_LIST'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 7,
              index: "/users",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UserFilled))
                  ]),
                  _: 1
                }),
                _createTextVNode(" Пользователи")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_menu_item, {
          index: "/statistic",
          onClick: handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Notebook))
              ]),
              _: 1
            }),
            _createTextVNode(" История")
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, {
          index: "/accruals",
          onClick: handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Money))
              ]),
              _: 1
            }),
            _createTextVNode(" Вознаграждения")
          ]),
          _: 1
        }),
        (_unref(can)('VIEW_API_TOKEN'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 8,
              index: "/api",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MagicStick))
                  ]),
                  _: 1
                }),
                _createTextVNode(" API")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_menu_item, {
          index: "/news",
          onClick: handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Postcard))
              ]),
              _: 1
            }),
            _createTextVNode(" Новости")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, { onClick: handleLogout }, {
          default: _withCtx(() => [
            _createTextVNode("Выйти")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})